// removed by extract-text-webpack-plugin
module.exports = {"reminder":"_1t1zD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReminderModal/AddToCalendarButton.scss
// module id = ./src/components/ReminderModal/AddToCalendarButton.scss
// module chunks = 4